import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ImportProvider } from './context/ImportContext';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { SpellsPage } from './pages/SpellsPage';
import { ItemsPage } from './pages/ItemsPage';
import { ClassesPage } from './pages/ClassesPage';
import { FeatsPage } from './pages/FeatsPage';
import { SelectionProvider } from './context/SelectionContext';
import './App.css';

function App() {
  return (
    <Router>
      <ImportProvider>
        <SelectionProvider>
          <div className="app">
            <Navigation />
            <main>
              <Routes>
                <Route path="/" element={<SpellsPage />} />
                <Route path="/spells" element={<SpellsPage />} />
                <Route path="/items" element={<ItemsPage />} />
                <Route path="/classes" element={<ClassesPage />} />
                <Route path="/feats" element={<FeatsPage />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </SelectionProvider>
      </ImportProvider>
    </Router>
  );
}

export default App;
